import { render, staticRenderFns } from "./ReportsLayout.vue?vue&type=template&id=4ec34a40&scoped=true&"
import script from "./ReportsLayout.vue?vue&type=script&lang=ts&"
export * from "./ReportsLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ReportsLayout.vue?vue&type=style&index=0&id=4ec34a40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec34a40",
  null
  
)

export default component.exports